export default function ReviewInput({ value, onChange, onSubmit, loading }) {
  return (
    <div className="reviewInput">
      <p className="inputTitle">환자 리뷰 내용:</p>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit?.();
        }}
      >
        <textarea
          name="textarea"
          rows="8"
          placeholder="이곳에 환자분이 남기신 리뷰를 붙여넣어 주세요 (예: 원장님도 친절하시고 다이어트 효과도 정말 좋아요)"
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          disabled={loading}
        />
        <button type="submit" className="submitbtn" disabled={loading}>
          {loading ? "생성 중…" : "리뷰 답변 생성하기"}
        </button>
      </form>
    </div>
  );
}
